/* Config */
import appConfig from '../../appConfig';

/* Constants */
import {ONE_MINUTE_MILISECOND} from '../../common/time/timeConstants';
import {CMS_COMPONENT_SOURCE_TYPES} from './homePageComponentsConstants';

/* Utils */
import {prepareHomepageComponentsWithBannerList} from './homePageComponentsUtils';
import {prepareRecommendationPayload, getComponentsByDirection} from '../cmsComponent/cmsComponentUtils';

function homePageComponentsApiFactory(storefrontApiClient) {
  const homePageComponents = {
    getHomePageComponents(params) {
      return storefrontApiClient.get('/homepagecomponents', {params}, {},
        {cacheKey: `homePageComponents-${params.platform}`, cacheStatus: true, expireTime: ONE_MINUTE_MILISECOND * 5});
    },
    getCmsHomePageComponents(params) {
      return storefrontApiClient.get('/getMobileHomePageComponents', {
        params,
      }, {}, {cacheKey: 'mobileHomePageComponents', cacheStatus: true, expireTime: ONE_MINUTE_MILISECOND * 5});
    },
    getHomepageComponentsWithBannerList(
      homepageComponents,
      params,
      userId,
      anonymousId,
      isPersonalizationEnabled,
      isLocationAwareAvailable,
      shouldRequestCustomerInfo,
      cacheKey
    ) {
      const cmsHomepageComponents = homepageComponents?.filter((cmp) => cmp?.dataSource === CMS_COMPONENT_SOURCE_TYPES.CMS)
      const personalizedComponents = cmsHomepageComponents?.filter((cmp) => cmp?.personalizedOrder)
      const componentIds = cmsHomepageComponents?.map((cmp) => cmp.id)
      const groupedComponents = getComponentsByDirection(personalizedComponents)

      return storefrontApiClient.get(`${appConfig.converterUrl}/api/1/mobilesite/banners/bulkfeaturelist/${componentIds.join(',')}`, {
        params,
        timeout: 2000,
      }, {}, {
        cacheKey: cacheKey || 'MobileBulkFeatureList',
        cacheStatus: !isLocationAwareAvailable && !shouldRequestCustomerInfo,
        expireTime: ONE_MINUTE_MILISECOND * 5
      }
      ).then(async(cmsBulkListResponse) => {
        const cmsBulkListData = cmsBulkListResponse?.data?.result?.data
        let recommendationBannerResponse = null

        if ((userId || anonymousId) && isPersonalizationEnabled) {
          const horizontalGroups = prepareRecommendationPayload(groupedComponents?.horizontal, cmsBulkListData)
          const verticalGroups = prepareRecommendationPayload(groupedComponents?.vertical, cmsBulkListData)
          const swimlaneGroups = prepareRecommendationPayload(groupedComponents?.swimlane, cmsBulkListData)

          let recommendationPayload = {
            userId,
            anonymousId,
            bannerMainGroupRequests: []
          }

          if (horizontalGroups?.length > 0) {
            recommendationPayload.bannerMainGroupRequests.push({
              definition: 'horizontal',
              bannerGroups: horizontalGroups
            })
          }

          if (verticalGroups?.length > 0) {
            recommendationPayload.bannerMainGroupRequests.push({
              definition: 'vertical',
              bannerGroups: verticalGroups
            })
          }

          if (swimlaneGroups?.length > 0) {
            recommendationPayload.bannerMainGroupRequests.push({
              definition: 'swimlane',
              bannerGroups: swimlaneGroups
            })
          }

          recommendationBannerResponse = isPersonalizationEnabled &&
            await storefrontApiClient.post(`${process.env.BROWSER ? appConfig.arfUrl: appConfig.arfServerUrl}/ranking/multiBanner`, recommendationPayload, {
              timeout: process.env.BROWSER ? appConfig.arfClientTimeoutInMilliseconds : appConfig.arfServerTimeoutInMilliseconds,
            }).catch((e) => {
              console.log('Failed fetch banner list from arf service', e.message)
            })
        }
        return prepareHomepageComponentsWithBannerList(recommendationBannerResponse, cmsBulkListData, homepageComponents)
      }).
        catch((e) => {
          console.log('Failed fetch bulk feature list from converter service', e.message)
        })
    }
  };

  return homePageComponents;
}

export default homePageComponentsApiFactory;
